import Vue from "vue";
import Router from "vue-router";
import config from "@/config";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "",
      component: () => import("@/views/default/index.vue"),
      children: [
        {
          path: "",
          redirect: "/login"
          // component: () => import("@/views/default/_home.vue")
        },
        {
          path: "/login",
          component: () => import("@/views/default/_login.vue")
        },
        {
          path: "/logout",
          component: () => import("@/views/default/_logout.vue")
        },
        {
          path: "/expired",
          component: () => import("@/views/default/_expired.vue")
        },
        {
          path: "/denied",
          component: () => import("@/views/default/_denied.vue")
        },
        {
          path: "/firstTime",
          component: () => import("@/views/default/_firstTime.vue"),
          meta: { requiredLoggedIn: true}
        },
        {
          path: "/security",
          component: () => import("@/views/default/_security.vue"),
          meta: { requiredLoggedIn: true}
        },
        {
          path: "/resetPassword",
          component: () => import("@/views/default/_resetPassword.vue"),
          meta: { requiredLoggedIn: true}
        },
        {
          path: "/signup",
          component: () => import("@/views/default/_signup.vue"),
        },
        {
          path: "/tac",
          component: () => import("@/views/default/_tac.vue"),
        }
      ]
    },
    {
      path: "/account",
      component: () => import("@/views/account/index.vue"),
      children: [
        {
          path: "/account/member",
          component: () => import("@/views/account/_member.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.member], subAccPage: [config.subAccessRoles.account] }
        },
        {
          path: "/account/subaccount",
          component: () => import("@/views/account/_subAccount.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.subaccount], subAccPage: [config.subAccessRoles.account] }
        },
      ],
      meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.member, config.accessRoles.subaccount], subAccPage: [config.subAccessRoles.account]}
    },
    {
      path: "/ticket",
      component: () => import("@/views/ticket/index.vue"),
      children: [
        {
          path: "/ticket/withdrawal",
          component: () => import("@/views/ticket/_withdrawal.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.withdrawal], subAccPage: [config.subAccessRoles.ticket] }
        }
      ],
      meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.withdrawal], subAccPage: [config.subAccessRoles.ticket]}
    },
    {
      path: "/bank",
      component: () => import("@/views/bank/index.vue"),
      children: [
        {
          path: "/bank/bankAffiliate",
          component: () => import("@/views/bank/_bankAffiliate.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.bankaffiliate], subAccPage: [config.subAccessRoles.bank] }
        }
      ],
      meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.bankaffiliate], subAccPage: [config.subAccessRoles.bank]}
    },
    {
      path: "/report",
      component: () => import("@/views/report/index.vue"),
      children: [
        {
          path: "/report",
          redirect: "/report/settlementList"
        },
        {
          path: "/report/settlementList",
          component: () => import("@/views/report/_settlementList.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.settlementlist], subAccPage: [config.subAccessRoles.report] }
        },
        {
          path: "/report/dailyWinLose",
          component: () => import("@/views/report/_dailyWinLose.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.dailywinlose], subAccPage: [config.subAccessRoles.report] }
        },
        {
          path: "/report/promoMember",
          component: () => import("@/views/report/_promoMember.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.promomember], subAccPage: [config.subAccessRoles.report] }
        }
      ],
      meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.settlementlist, config.accessRoles.dailywinlose, config.accessRoles.promomember], subAccPage: [config.subAccessRoles.report] }
    },
    {
      path: "/system",
      component: () => import("@/views/system/index.vue"),
      children: [
        {
          path: "/system/setting",
          component: () => import("@/views/system/_setting.vue"),
          meta: { requiredLoggedIn: true }
        },
        {
          path: "/system/dashboard",
          component: () => import("@/views/system/_dashboard.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.dashboard], subAccPage: [config.subAccessRoles.system] }
        },
      ],
      meta: { requiredLoggedIn: true, includedPages: [], subAccPage: [config.subAccessRoles.system]}
    },
  ]
});

export default router;
